import React from 'react';
import { Button, Modal, Form } from 'react-bootstrap';

interface Props {
  show: boolean;
  onHide: () => void;
  selectedOrderItem: any;
  selectedOrderId: any;
  selectedOrderItemId: any;
  onApprove: (e: any) => void;
}

export const PartiallyApproveModal: React.FC<Props> = ({ show, onHide, selectedOrderItem, selectedOrderId, selectedOrderItemId, onApprove }) => {
  return (
    <Modal autoFocus={true} show={show} onHide={onHide} dialogClassName="modal-90w">
      <Modal.Header closeButton>
        <Modal.Title>✂️ Parçalı Onay</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {/* 🔥 DÜZELTME: Sadece toplam adeti gösteriyoruz */}
        <p className="lead">
          Toplam Sipariş: <strong>{selectedOrderItem?.quantity}</strong> Adet
        </p>

        <div className="centered-80-percent margin-left-right-40">
          <Form onSubmit={onApprove}>
            <Form.Group className="mb-4" controlId="formAmount">
              <Form.Label>Onaylanacak Miktar (Adet)</Form.Label>
              {/* 🔥 DÜZELTME: step="any" veya "0.01" ile ondalık sayıya izin veriyoruz */}
              <Form.Control
                name="partialQuantity"
                type="number"
                step="0.01"
                max={selectedOrderItem?.quantity} // Toplam adetten fazlasını giremesin
                placeholder="Örn: 1.5 veya 5"
                required
              />
            </Form.Group>

            <input type="hidden" name="orderId" value={selectedOrderId}></input>
            <input type="hidden" name="orderItemId" value={selectedOrderItemId}></input>

            <Button className="btn btn-primary btn-lg btn-block" type="submit">
              Onayla
            </Button>
          </Form>
        </div>
      </Modal.Body>
    </Modal>
  );
};